module.exports = __webpack_public_path__ + "static/media/hifi-01.945405d1.png";